<div class="tp-wrapper" [class.tp-disabled]="disabled">
  @if (label) {
    <label class="tp-label" [for]="inputId">
      {{ label }}
      @if (required) {
        <span class="tp-required">*</span>
      }
    </label>
  }

  <!-- Input + clock icon -->
  <div
    class="tp-field"
    [class.tp-field-open]="isOpen()"
    [class.tp-field-error]="hasError"
    [class.tp-field-disabled]="disabled"
  >
    <input
      class="tp-input"
      type="text"
      [id]="inputId"
      [placeholder]="timePlaceholder()"
      [disabled]="disabled"
      [value]="inputText"
      (input)="onInputChange($event)"
      (keydown)="onInputKeyDown($event)"
      (paste)="onInputPaste($event)"
      (blur)="onInputBlur()"
      (click)="$event.stopPropagation()"
      autocomplete="off"
      [attr.aria-label]="label || timePlaceholder()"
      [attr.aria-required]="required"
      [attr.aria-invalid]="hasError"
      [attr.aria-expanded]="isOpen()"
    />
    <button
      type="button"
      class="tp-toggle-btn"
      [disabled]="disabled"
      (click)="togglePanel($event)"
      [attr.aria-label]="isOpen() ? 'Saati kapat' : 'Saat seç'"
    >
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="7.5" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 6.5V10.5L12.5 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Fixed-position panel: renders outside any overflow:hidden ancestor -->
  @if (isOpen()) {
    <div
      class="tp-panel"
      [class.tp-panel--above]="panelAbove()"
      [style.top]="panelStyle().top"
      [style.left]="panelStyle().left"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      (mousedown)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="tp-panel-header">
        <span class="tp-panel-label">{{ hourLabel() }}</span>
        <span class="tp-panel-sep"></span>
        <span class="tp-panel-label">{{ minuteLabel() }}</span>
      </div>

      <div class="tp-columns">
        <div class="tp-col tp-col-hours" role="listbox">
          @for (h of HOURS; track h) {
            <button
              type="button"
              class="tp-item"
              [class.tp-item-selected]="selectedHour() === h"
              (click)="selectHour($event, h)"
              role="option"
              [attr.aria-selected]="selectedHour() === h"
            >
              {{ h | number: '2.0-0' }}
            </button>
          }
        </div>

        <div class="tp-divider">:</div>

        <div class="tp-col tp-col-minutes" role="listbox">
          @for (m of MINUTES; track m) {
            <button
              type="button"
              class="tp-item"
              [class.tp-item-selected]="selectedMinute() === m"
              (click)="selectMinute($event, m)"
              role="option"
              [attr.aria-selected]="selectedMinute() === m"
            >
              {{ m | number: '2.0-0' }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  @if (hasError && errorText) {
    <span class="tp-error-text" role="alert">{{ errorText }}</span>
  }
</div>
